<script>
import CurrentUser from './CurrentUser'
export default {

  computed: {
    userName() {
      let user = CurrentUser.get()
      if (user) {
        return user.first_name
      }
      return ''
    }
  }

}
</script>

<template>
  <nav>
    <div class="columns is-mobile">
      <div class="column">
        <b-button type="is-text" @click="$emit('clickUser')">Hi {{ userName }}!</b-button>
      </div>
      <div class="column has-text-right">
        <b-button @click="$emit('logout')">Logout</b-button>
      </div>
    </div>
  </nav>
</template>

<style lang="scss">

</style>